const texts = {
  title: 'به زیما خوش آمدید',
  form: {
    mobileNumber: {
      label: 'شماره موبایل',
      placeholder: 'شماره موبایل خود را وارد کنید',
      helperText: 'شماره موبایل معتبر نمی باشد',
    },
    referralCode: {
      label: 'کد معرف دارید؟',
    },
    button: 'ورود / ثبت‌نام',
  },
}

export default texts
